// extracted by mini-css-extract-plugin
export default {"app":"style_app__kQQpV","btn-reset":"style_btn-reset__MrMl1","list-reset":"style_list-reset__+ZoFg","container":"style_container__QhhWp","centering":"style_centering__CmMUV"};